// extracted by mini-css-extract-plugin
export default {"portfolio_home":"Home_portfolio_home__vSghj","portfolio_card":"Home_portfolio_card__49kes"};